import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  switch(event) {
    event.preventDefault();
    event.stopPropagation();
    const link = event.currentTarget;
    const interval = link.dataset.interval;
    
    // Update all form hidden fields with billing_interval immediately
    // This ensures the form has the correct value even if submitted before navigation completes
    document.querySelectorAll("input[name*=\"[billing_interval]\"]").forEach(input => {
      input.value = interval;
    });
    
    // Store current scroll position before navigation
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    
    // Update URL without reload using Turbo
    if (window.Turbo) {
      // Get current URL and update billing_interval parameter
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("billing_interval", interval);
      
      // Remove anchor to prevent auto-scroll
      currentUrl.hash = "";
      
      // Store scroll position in sessionStorage
      sessionStorage.setItem("billingToggleScroll", scrollY.toString());
      sessionStorage.setItem("billingToggleRestore", "true");
      
      // Prevent Turbo from scrolling by intercepting before-visit
      const preventScroll = (_e) => {
        // Store scroll position again right before navigation
        const currentScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        sessionStorage.setItem("billingToggleScroll", currentScroll.toString());
      };
      
      // Restore scroll after navigation completes
      const restoreScroll = () => {
        if (sessionStorage.getItem("billingToggleRestore") === "true") {
          const storedScroll = parseFloat(sessionStorage.getItem("billingToggleScroll") || "0");
          
          // Immediately restore scroll position
          window.scrollTo({ top: storedScroll, behavior: "instant" });
          
          // Use multiple attempts to ensure scroll is restored (Turbo might scroll after render)
          requestAnimationFrame(() => {
            window.scrollTo({ top: storedScroll, behavior: "instant" });
          });
          
          setTimeout(() => {
            window.scrollTo({ top: storedScroll, behavior: "instant" });
          }, 0);
          
          setTimeout(() => {
            window.scrollTo({ top: storedScroll, behavior: "instant" });
            sessionStorage.removeItem("billingToggleScroll");
            sessionStorage.removeItem("billingToggleRestore");
          }, 100);
        }
      };
      
      // Listen for Turbo events
      document.addEventListener("turbo:before-visit", preventScroll, { once: true });
      document.addEventListener("turbo:load", restoreScroll, { once: true });
      document.addEventListener("turbo:render", restoreScroll, { once: true });
      
      // Use Turbo to visit the new URL
      window.Turbo.visit(currentUrl.toString(), {
        action: "replace"
      });
    } else {
      // Fallback to regular navigation
      window.location.href = link.href;
    }
  }
}

